import Modal from '@mui/material/Modal';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";

const DetailData = ({ open, handleClose, selectedRow }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
    >
      <Box sx={{
        position: 'absolute',
        top: '20%',
        left: '50%',
        transform: 'translate(-50%, -20%)',
        minWidth: 600,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
      }}>
        <Typography id="modal-modal-title">
          <h6><b>Detail Data</b></h6>
        </Typography>
        <hr></hr>
        {selectedRow &&
          <TableContainer sx={{ maxHeight: '450px', overflowY: 'auto' }}>
            <Table size="small" aria-label="a dense table">
              <TableBody>
                <TableRow>
                  <TableCell width={'30%'} component="th" scope="row"><b>Name</b></TableCell>
                  <TableCell>: {selectedRow.leadName}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell width={'30%'} component="th" scope="row"><b>Jenis Kelamin</b></TableCell>
                  <TableCell>: {selectedRow.gender == 'F'?'Perempuan':'Laki - laki'}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell width={'30%'} component="th" scope="row"><b>Telepon Seluler</b></TableCell>
                  <TableCell>: {selectedRow.phone}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell width={'30%'} component="th" scope="row"><b>Email</b></TableCell>
                  <TableCell>: {selectedRow.email}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell width={'30%'} component="th" scope="row"><b>Kota</b></TableCell>
                  <TableCell>: {selectedRow.city}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell width={'30%'} component="th" scope="row"><b>Jml. Polis</b></TableCell>
                  <TableCell>: {selectedRow.policyCount}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell width={'30%'} component="th" scope="row"><b>Jml. Referral Fee</b></TableCell>
                  <TableCell>: {selectedRow.referralFee}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        }
        <br />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: 2,
          }}>
          <Button
            variant="contained"
            onClick={handleClose}
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DetailData;
